
<template>
  <div class="px-3">
    現在選択中の企業: <b-form-select @change="onChnageOrganization()" v-model="currentOrg" class='dirty w50 ml-2' :options="linkList"></b-form-select>
  </div>
</template>
<script>
import axios from 'axios';
export default {
  components: {
  },
  props:{
  },
  data() {
    return{
      idToken: localStorage.idToken,
      linkList: [],
      agency: {},
      currentOrg: "",
    }
  },
  methods:{
    onChnageOrganization() {
      axios
        .patch(process.env.VUE_APP_API + "/api/agcy/agency/1", {organization: {current_organization_id: this.currentOrg}} ,{headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(res => {
          console.log(res)
          this.$emit("update")
        })
    },
    fetchLink() {
      axios
        .get(process.env.VUE_APP_API + "/api/agcy/agency_partner?state=apply", {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          response.data.forEach((r) => {
            this.linkList.push({value: r.organization_id, text: r.name})
          })
        }).catch(error => {
          console.log('this is org error', error)
        })
    }
  },
  mounted(){
    try {
      this.fetchLink()
      axios
        .get(process.env.VUE_APP_API + "/api/agcy/agency/1", {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(res => {
            this.agency = res.data.agency
            this.currentOrg = this.agency.current_organization_id
        })
    } catch(e) {
      console.log("_------")
      console.log(e)
    }

  },
}

</script>
<style type="text/css" scoped="">
.w50 {
  width: 50%;
}
</style>
